import ENDPOINTS from "@/lib/endpoints";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

// Async thunk to fetch sections
export const fetchSections = createAsyncThunk(
  "settings/fetchSections",
  async () => {
    const baseUrl = process.env.NEXT_PUBLIC_API_URL.replace(/\/$/, "");
    const response = await fetch(baseUrl + ENDPOINTS.ALL_SECTIONS);
    const data = await response.json();

    return data;
  }
);

// Initial state with an empty array for sections
const initialState = {
  sections: [],
  status: "idle", // "idle" | "loading" | "succeeded" | "failed"
  error: null,
};

// Redux slice
const frontendSlice = createSlice({
  name: "frontendData",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchSections.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchSections.fulfilled, (state, { payload }) => {
        state.status = "succeeded";

        if (payload.status === "error") {
          state.sections = [];
          state.error = payload.message || "Unknown error";
        } else if (Array.isArray(payload)) {
          state.sections = payload; // If payload is directly an array
        } else if (payload && Array.isArray(payload.data)) {
          state.sections = payload.data; // If sections are inside a `data` key
        } else {
          state.sections = [];
        }
      })
      .addCase(fetchSections.rejected, (state, action) => {
        state.status = "failed";
        state.sections = [];
        state.error = action.error.message;
      });
  },
});

// Safe selector function
export const selectSectionByKey = (state, key) =>
  Array.isArray(state.frontend.sections)
    ? state.frontend.sections.find((s) => s.key === key)
    : undefined;

export default frontendSlice.reducer;
